export const PROJECTS = [
  { 
    id: "studentsummit", 
    title: "STUDENT SUMMIT", 
    category: "Event Ecosystem / Custom WordPress", 
    year: "2026", 
    image: "/portfolio/studentsummit-banner.webp", 
    description: "A high-performance digital platform engineered for Australia's premier student event. By integrating seamless registration flows with immersive scroll interactions and a streamlined Elementor architecture, we delivered a kinetic ecosystem that drives user engagement.",
    link: "https://studentsummit.com.au/"
  },
  { 
    id: "cluckd", 
    title: "CLUCK'D", 
    category: "Digital Storefront / E-Commerce", 
    year: "2026", 
    image: "/portfolio/cluckd-cover.jpg", 
    description: "A high-performance digital storefront and online ordering ecosystem engineered for a premium UK-based restaurant. Built on a robust WordPress foundation, the platform integrates seamless 'Click & Collect' workflows with striking, dynamic imagery to drive high-volume local conversions.",
    link: "https://cluckd.co.uk/"
  },
  { 
    id: "theboardbabes", 
    title: "THE BOARD BABES", 
    category: "Luxury Event Design / Elementor", 
    year: "2026", 
    image: "/portfolio/theboardbabes-cover.jpg", 
    description: "A high-end digital storefront engineered for a luxury catering and event styling brand. The platform features an immersive, visual-first aesthetic, seamlessly integrating complex e-commerce workflows for custom grazing tables and digital workshop bookings.",
    link: "https://www.theboardbabesnwf.com/"
  },
  { 
    id: "lewalkcosmetics", 
    title: "LE WALK COSMETICS", 
    category: "B2B E-Commerce / WordPress", 
    year: "2026", 
    image: "/portfolio/lewalkcosmetics-cover.jpg", 
    description: "A professional, clinical-grade B2B e-commerce ecosystem built for a natural cosmetics manufacturer. The architecture supports high-volume wholesale transactions, dynamic product variations, and an integrated online training portal for licensed estheticians.",
    link: "https://lewalkcosmetic.com/"
  },
  { 
    id: "pharmafiore", 
    title: "PHARMA FIORE", 
    category: "Clean Beauty / WebGL", 
    year: "2026", 
    image: "/portfolio/pharmafiore-cover.jpg", 
    description: "An elegant, conversion-optimized storefront for an Italian alchemical skincare brand. The interface translates the brand's natural ethos into a fluid digital experience, utilizing custom motion and smooth navigation to showcase vibrational active ingredients.",
    link: "https://illaboratorioalchemico.it/"
  },
  { 
    id: "htplglobal", 
    title: "HTPL GLOBAL", 
    category: "Enterprise Architecture / UI/UX", 
    year: "2026", 
    image: "/portfolio/htplglobal-cover.jpg", 
    description: "A corporate digital hub designed for a leading enterprise hospitality technology provider. The architecture prioritizes B2B lead generation, clearly framing complex POS and property management solutions for global hotel and casino clients.",
    link: "https://www.htplglobal.com/"
  },
  { 
    id: "rinkii", 
    title: "RINKII", 
    category: "Custom E-Commerce / API Integration", 
    year: "2026", 
    image: "/portfolio/rinkii-cover.jpg", 
    description: "A highly interactive digital boutique for personalized, handmade gifts. The platform manages complex, multi-variant user inputs for custom 3D portraits and puzzles, ensuring a frictionless transition from selection to checkout.",
    link: "https://rinkii.com/"
  },
  { 
    id: "blossomsworld", 
    title: "BLOSSOMS WORLD", 
    category: "Venture Studio / Minimalist Design", 
    year: "2025", 
    image: "/portfolio/blossomsworld-cover.jpg", 
    description: "A sleek, intention-driven corporate presence for a venture and growth studio. The site employs a minimalist, architectural structure to guide high-value clients through strategic service funnels and partnership opportunities.",
    link: "https://blossomsworldllc.com/"
  },
  { 
    id: "lbisurfing", 
    title: "LBI SURFING", 
    category: "Booking Engine / Local SEO", 
    year: "2025", 
    image: "/portfolio/lbisurfing-cover.jpg", 
    description: "A dynamic, high-traffic booking platform for a premier surf school and rental shop. The WordPress architecture integrates a robust scheduling system and equipment rental workflow, perfectly optimized for local search dominance.",
    link: "https://lbisurfing.com/"
  },
  { 
    id: "alzizinternational", 
    title: "ALZIZ INTERNATIONAL", 
    category: "Multi-Vertical Hub / Global Ops", 
    year: "2025", 
    image: "/portfolio/alzizinternational-cover.jpg", 
    description: "A large-scale corporate portal managing operations across multiple verticals, including real estate, agriculture, and global finance. The architecture effectively segments diverse service offerings into a unified, navigable ecosystem.",
    link: "https://alzizinternational.com/"
  },
  { 
    id: "ludmilasnetlab", 
    title: "LUDMILA'S NETLAB", 
    category: "E-Learning / LMS Integration", 
    year: "2025", 
    image: "/portfolio/ludmilasnetlab-cover.jpg", 
    description: "A focused educational platform providing online networking and SAP classes. The digital structure integrates an efficient booking engine and bilingual capabilities to support a diverse, international student base.",
    link: "https://ludmilasnetlab.com/"
  },
  { 
    id: "manosphotography", 
    title: "MANOS PHOTOGRAPHY", 
    category: "Visual Portfolio / Client Portals", 
    year: "2025", 
    image: "/portfolio/manosphotography-cover.jpg", 
    description: "A highly visual, media-rich portfolio designed for a professional wedding photographer. The platform features secure client gallery portals and integrated e-signing, prioritizing image delivery speed without sacrificing resolution.",
    link: "https://manosphotography.com/"
  },
  { 
    id: "chanpunkt", 
    title: "CHAN PUNKT", 
    category: "Personal Branding / Consulting", 
    year: "2025", 
    image: "/portfolio/chanpunkt-cover.jpg", 
    description: "A streamlined, minimalist digital presence for a Munich-based author and consultant. The site prioritizes typography and negative space, functioning as a clean, direct touchpoint for professional inquiries.",
    link: "https://chanpunkt.com/"
  }
];

export const TESTIMONIALS = [
  { 
    id: "testi-1", 
    name: "Gloria B.", 
    role: "Client — Spain", 
    quote: "I have repeatedly worked with Mr Sid due to his great understanding of my brief, professional results, and quick communication. He makes my website elevated and visually attractive." 
  },
  { 
    id: "testi-2", 
    name: "Kimberly Brown", 
    role: "Client — United States", 
    quote: "Mohd is a great find! He went above and beyond to get my website perfect. He is my go-to for all things website. This is my 5th time hiring him, and I will continue to do so." 
  },
  { 
    id: "testi-3", 
    name: "Finn Slade", 
    role: "Client — Uganda", 
    quote: "Mohd Kaif did an exceptional job. He was incredibly professional, listened to all my requirements, and patiently made revisions until everything was exactly the way I wanted." 
  },
  { 
    id: "testi-4", 
    name: "Abdalslam Ali", 
    role: "Client — Egypt", 
    quote: "Great working with Kaif, an absolute expert in Elementor and premium WordPress builds. Highly recommended for high-performance sites." 
  },
  { 
    id: "testi-5", 
    name: "ECDT", 
    role: "Client — United States", 
    quote: "I always get exactly what I ask for when working with him. Thank you for your patience, technical execution, and for truly seeing my vision." 
  },
];

export const PHASES = [
  { 
    id: "discovery", 
    num: "01", 
    title: "DISCOVERY", 
    color: "var(--pf-accent)", 
    details: "Deep research, strategy sprints & moodboards. I map your brand's gravity before a single pixel moves — user flows, sitemaps, motion prototypes." 
  },
  { 
    id: "development", 
    num: "02", 
    title: "DEVELOPMENT", 
    color: "var(--pf-orange)", 
    details: "GSAP timelines, WordPress & Elementor architecture, custom WebGL shaders. Every interaction engineered at 60fps with production-grade code." 
  },
  { 
    id: "deployment", 
    num: "03", 
    title: "DEPLOYMENT", 
    color: "var(--pf-lime)", 
    details: "Performance audits, Core Web Vitals tuning, SEO wiring & launch. Then AI-powered analytics loops to keep the ecosystem evolving." 
  },
];

export const TECH_TAGS = [
  "REALISTIC RENDERING", 
  "RAW MOTION", 
  "AI GENERATION", 
  "POST-PRODUCTION AUDIO", 
  "DYNAMIC LIGHTING", 
  "WEBGL PHYSICS"
];

export const SOCIALS = [
  { label: "LINKEDIN", url: "https://www.linkedin.com/in/imohdkaif/" },
  { label: "WHATSAPP", url: "https://wa.me/919939403048?text=Hi%20Mr.%20Sid!%20I%20would%20love%20to%20discuss%20a%20project." },
];

export const EMAIL = "HELLO@MOHDKAIF.COM";
